import { useState } from 'react';
import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { useAuthContext } from '../../../../contexts/AuthContext';
import { useAppContext } from '../../../../contexts/AppContext';
import { UserService } from '../Service';
import { SettingsRow, SettingsSection } from '../../estabelecimento/Form/SettingsGroup';

const service = new UserService();

export default function ConfiguracoesContaPassword() {
    const { successSnackbar, errorSnackbar } = useAppContext();

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const { user } = useAuthContext();
    const auth = getAuth();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (newPassword !== confirmPassword) {
            errorSnackbar('As novas senhas não coincidem.');
            return;
        }

        if (user) {
            setLoading(true);
            try {
                const userCredential = EmailAuthProvider.credential(user.email!, currentPassword);
                await reauthenticateWithCredential(auth.currentUser!, userCredential);
                await updatePassword(auth.currentUser!, newPassword);
                successSnackbar('Senha atualizada com sucesso!');

                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            } catch (error: any) {
                errorSnackbar('Erro ao atualizar a senha.');
            } finally {
                setLoading(false);
            }
        }
    };

    const recoverPassword = async () => {
        try {
            if (!!user?.email) {
                await service.requestRecoverPassword(user?.email);
            }

            successSnackbar('E-mail enviado com instruções para restaurar a senha!');
        } catch (e) {
            errorSnackbar('Erro ao enviar e-mail para redefinir a senha.');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
                <SettingsSection
                    title="Verificação"
                    footer={
                        <button type="button" onClick={recoverPassword} className="estab-link-button -ml-1 !text-xs">
                            Esqueceu sua senha?
                        </button>
                    }
                >
                    <SettingsRow label="Senha atual" htmlFor="currentPassword">
                        <input
                            type="password"
                            id="currentPassword"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            required
                            className="input estab-field"
                            autoComplete="current-password"
                        />
                    </SettingsRow>
                </SettingsSection>

                <SettingsSection title="Nova senha">
                    <SettingsRow label="Nova senha" htmlFor="newPassword">
                        <input
                            type="password"
                            id="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            className="input estab-field"
                            autoComplete="new-password"
                        />
                    </SettingsRow>
                    <SettingsRow label="Confirmar senha" htmlFor="confirmPassword">
                        <input
                            type="password"
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            className="input estab-field"
                            autoComplete="new-password"
                        />
                    </SettingsRow>
                </SettingsSection>
            </div>

            <div className="estab-savebar mt-6">
                <button
                    className="btn btn-primary w-full sm:w-auto sm:min-w-[11rem]"
                    type="submit"
                    disabled={loading}
                >
                    {loading && <span className="loading loading-spinner loading-sm"></span>}
                    Salvar alterações
                </button>
            </div>
        </form>
    );
}
